import axios from "axios";
import { getCoInvAISummary, getPEAISummary, getPEInvAISummary, getCFSAISummary } from "../Config/config";

export const fetchAISummary = async (id) => {
  try {
    const response = await axios.post(
      `${getPEAISummary}/${id}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.log(error, "Error Generating AI Summary");
    throw error;
  }
};

export const fetchCFSAISummary = async (id) => {
  try {
    const response = await axios.post(
      `${getCFSAISummary}/${id}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.log(error, "Error Generating AI Summary");
    throw error;
  }
};

export const fetchInvestorAISummary = async (id) => {
  try {
    const response = await axios.post(
      `${getPEInvAISummary}/${id}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.log(error, "Error Generating AI Summary");
    throw error;
  }
};

export const coInvestorAISummary = async (id) => {
  try {
    const response = await axios.post(
      `${getCoInvAISummary}/${id}`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.log(error, "Error Generating AI Summary");
    throw error;
  }
}